// extracted by mini-css-extract-plugin
module.exports = {"body":"HomePage_body__3EKc2","container":"HomePage_container__2QaZw"};